var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricalWires(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.53 55.84A27.001 27.001 0 0141.26 65H31v-4h10.26a23 23 0 0022.79-26 21.413 21.413 0 00-1.41-5.36h-.05a13.49 13.49 0 00-15-7c-5.47 1.32-8.6 6-8.6 12.79V37h2v8H33v-8h2v-1.6c0-8.68 4.36-14.92 11.67-16.68a16.476 16.476 0 012.93-.43C42.8 16.92 38 18.88 35 21a19.57 19.57 0 00-8 15.59V37h2v8h-8v-8h2.06v-.41a23.24 23.24 0 019.66-18.76 20.78 20.78 0 014.83-2.53C24 16.82 15.44 25 15 37h2v8H9v-8h2c.47-14.26 11-24.34 27-25.79 14.75-1.34 28.21 9.09 30 23.25a27.13 27.13 0 01-6.47 21.38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electrical_wires.5ca9cfc3.svg";
export { SvgA4ElectricalWires as ReactComponent };